module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAABVQTFRF+PjISDhQgHhwoECg2IC4+Pj4////d46BGgAAAAF0Uk5TAEDm2GYAAABvSURBVBjTZc5RCoJBCARggw5QdIMRD5Dme/B3goG5/1XCrZetQVj8UFk7v7Y87agtD6ufWIklF5ulYrsVI8CpABUDHc52ZvgHxAUxKM0EeiAjnFxQC9bmF1IQgxA4N1AFBxLzpP9/7Lb3dztdt1zeufgtXfWdGtAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Poison.png
// module id = 170
// module chunks = 0